{
  "name": "41edo (Septimal-Tertial Notation)",
  "description": "41-tone equal tempered scale consisting of 41 sonically equal divisions per octave. This is the smallest of the equal temperaments in which the lower primes 3, 5, 7, 11, 13 are all presented with minimal mistuning. Step-size is 29.3 cents, close to a Septimal Comma.",
  "scale": [
    "1\\41",
    "2\\41",
    "3\\41",
    "4\\41",
    "5\\41",
    "6\\41",
    "7\\41",
    "8\\41",
    "9\\41",
    "10\\41",
    "11\\41",
    "12\\41",
    "13\\41",
    "14\\41",
    "15\\41",
    "16\\41",
    "17\\41",
    "18\\41",
    "19\\41",
    "20\\41",
    "21\\41",
    "22\\41",
    "23\\41",
    "24\\41",
    "25\\41",
    "26\\41",
    "27\\41",
    "28\\41",
    "29\\41",
    "30\\41",
    "31\\41",
    "32\\41",
    "33\\41",
    "34\\41",
    "35\\41",
    "36\\41",
    "37\\41",
    "38\\41",
    "39\\41",
    "40\\41",
    "2/1"
  ],
  "key_colors_mode": "manual",
  "short_description": "41edo",
  "built_in_group": "Equal Divisions",
  "key_labels": "note_names",
  "note_names": [
    "C",
    "C",
    "D",
    "D",
    "C",
    "C",
    "D",
    "D",
    "D",
    "E",
    "E",
    "D",
    "D",
    "E",
    "E",
    "E",
    "F",
    "F",
    "F",
    "G",
    "G",
    "F",
    "F",
    "G",
    "G",
    "G",
    "A",
    "A",
    "G",
    "G",
    "A",
    "A",
    "A",
    "B",
    "B",
    "A",
    "A",
    "B",
    "B",
    "B",
    "C"
  ],
  "note_colors": [
    "#ffa9a9",
    "#e2caca",
    "#ffe5e5",
    "#d0d0d7",
    "#dee2da",
    "#d0d6e1",
    "#fffae5",
    "#ffffff",
    "#e2caca",
    "#ffe5e5",
    "#d0d0d7",
    "#dee2da",
    "#d0d6e1",
    "#fffae5",
    "#ffffff",
    "#e2caca",
    "#fffae5",
    "#ffffff",
    "#e2caca",
    "#ffe5e5",
    "#d0d0d7",
    "#dee2da",
    "#d0d6e1",
    "#fffae5",
    "#ffffff",
    "#e2caca",
    "#ffe5e5",
    "#d0d0d7",
    "#dee2da",
    "#d0d6e1",
    "#fffae5",
    "#ffffff",
    "#e2caca",
    "#ffe5e5",
    "#d0d0d7",
    "#dee2da",
    "#d0d6e1",
    "#fffae5",
    "#ffffff",
    "#e2caca",
    "#fffae5"
  ],
  "equivSteps": 41,
  "fundamental": 440,
  "reference_degree": 31,
  "center_degree": 0,
  "rSteps": 7,
  "drSteps": 3,
  "hexSize": 42,
  "rotation": -16.102113751
}
